/* Scoped progressive enhancement. Filters/sort/cart keep native HTML fallbacks.
   Cart POST is deliberately not intercepted: Shopify owns inventory and errors. */
(() => {
  const key = '__totokaVisualV2';
  if (window[key]) return;
  const mounted = new Map();
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),summary,[tabindex="0"]';
  function mount(root) {
    if (mounted.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const mobile = matchMedia('(max-width: 899px)');
    const sidebar = root.querySelector('.totoka-editorial-grid__sidebar');
    const trigger = root.querySelector('[data-teg-open]');
    let opened = false;
    let savedOverflow = '';
    let outside = [];
    function toggle(open, restoreFocus = true) {
      if (!sidebar || (open && !mobile.matches)) return;
      if (open === opened) return;
      opened = open;
      root.classList.toggle('is-filter-open', open);
      trigger?.setAttribute('aria-expanded', String(open));
      if (open) {
        savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        sidebar.inert = false;
        sidebar.setAttribute('role', 'dialog');
        sidebar.setAttribute('aria-modal', 'true');
        // Inert everything outside the modal's ancestor chain. Record state so
        // other theme dialogs keep their own inert settings after closing.
        let child = sidebar;
        outside = [];
        while (child.parentElement && child !== document.body) {
          for (const sibling of child.parentElement.children) {
            if (sibling === child || sibling.matches('[data-teg-close]')) continue;
            outside.push([sibling, sibling.inert]);
            sibling.inert = true;
          }
          child = child.parentElement;
        }
        sidebar.querySelector('[data-teg-close]')?.focus();
      } else {
        document.documentElement.style.overflow = savedOverflow;
        for (const [node, wasInert] of outside) node.inert = wasInert;
        outside = [];
        sidebar.removeAttribute('role');
        sidebar.removeAttribute('aria-modal');
        sidebar.inert = mobile.matches;
        if (restoreFocus) trigger?.focus();
      }
    }
    root.dataset.ttvReady = 'true';
    if (sidebar) sidebar.inert = mobile.matches;
    root.addEventListener('click', event => {
      if (event.target.closest('[data-teg-open]')) toggle(true);
      else if (event.target.closest('[data-teg-close]')) toggle(false);
    }, { signal });
    root.addEventListener('keydown', event => {
      if (!opened) return;
      if (event.key === 'Escape') { event.preventDefault(); toggle(false); }
      if (event.key === 'Tab') {
        const nodes = [...sidebar.querySelectorAll(focusable)].filter(el => el.getClientRects().length);
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }, { signal });
    mobile.addEventListener('change', () => {
      if (!mobile.matches) toggle(false, false);
      if (sidebar) sidebar.inert = mobile.matches && !opened;
    }, { signal });
    root.querySelector('[data-teg-sort]')?.addEventListener('change', event => event.target.form.requestSubmit(), { signal });
    mounted.set(root, () => {
      toggle(false, false);
      controller.abort();
      if (sidebar) sidebar.inert = false;
      delete root.dataset.ttvReady;
      mounted.delete(root);
    });
  }
  function scan(scope = document) {
    scope.querySelectorAll('[data-ttv-catalog]').forEach(mount);
  }
  window[key] = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once:true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of mounted) if (event.target.contains(root)) cleanup();
  });
})();
